export const ORDER_FORM_V2_FLAG = "order_form_v2";
